import { useEffect } from 'react';

const { BodyScrollManager } = window;

export default (scrollableRef) => {
  useEffect(() => {
    BodyScrollManager.disable(scrollableRef.current);
    return () => { BodyScrollManager.enable(scrollableRef.current); };
  }, []);
};
